{
  "hero.title": "멀티 CLI 환경 스위처",
  "hero.tagline-1": "선(禪)과 같은 플로우 상태로 코딩하세요.",
  "hero.tagline-2": "원활한 환경 전환.",
  "hero.subtitle": "Claude Code, Codex, OpenCode 설정을 통합 관리하고 API 프록시 자동 페일오버 지원",
  "hero.getDocs": "문서 보기",
  "features.title": "기능",
  "features.multiCli.title": "멀티 CLI 지원",
  "features.multiCli.desc": "Claude Code, Codex, OpenCode 지원, 프로젝트별 설정 가능",
  "features.multiConfig.title": "멀티 설정 관리",
  "features.multiConfig.desc": "통합된 JSON 파일에서 모든 API 프로바이더 설정 관리",
  "features.daemon.title": "통합 데몬",
  "features.daemon.desc": "단일 zend 프로세스로 프록시 서버와 웹 관리 UI를 동시에 호스팅",
  "features.failover.title": "프록시 페일오버",
  "features.failover.desc": "내장 HTTP 프록시, 기본 프로바이더 사용 불가 시 자동으로 백업으로 전환",
  "features.routing.title": "시나리오 라우팅",
  "features.routing.desc": "요청 특성(thinking, image 등)에 따라 다른 프로바이더로 지능적 라우팅",
  "features.binding.title": "프로젝트 바인딩",
  "features.binding.desc": "디렉토리를 특정 profile과 CLI에 바인딩하여 프로젝트 수준 자동 설정 실현",
  "features.envVars.title": "환경 변수",
  "features.envVars.desc": "프로바이더 수준에서 각 CLI의 환경 변수를 개별 설정",
  "features.webUi.title": "웹 UI",
  "features.webUi.desc": "브라우저에서 시각적 관리, 비밀번호 보호 접근 지원",
  "features.webSecurity.title": "웹 보안",
  "features.webSecurity.desc": "접근 비밀번호 자동 생성, 세션 인증, RSA 암호화 토큰 전송",
  "features.configSync.title": "설정 동기화",
  "features.configSync.desc": "WebDAV/S3/GitHub를 통해 기기 간 설정 동기화, AES-256-GCM 암호화 사용",
  "features.comingSoon": "더 많은 기능이 곧 출시됩니다",
  "install.title": "빠른 시작",
  "install.step1.title": "GoZen 설치",
  "install.step1.desc": "원라인 설치 스크립트",
  "install.step2.title": "프로바이더 설정",
  "install.step2.desc": "첫 번째 API 프로바이더 추가",
  "install.step3.title": "시작",
  "install.step3.desc": "기본 설정으로 CLI 시작",
  "commands.title": "명령어 목록",
  "commands.command": "명령어",
  "commands.description": "설명",
  "commands.items.start": "CLI 시작 (프로젝트 바인딩 또는 기본 설정 사용)",
  "commands.items.profile": "지정된 profile로 시작",
  "commands.items.profilePick": "profile을 대화형으로 선택",
  "commands.items.cli": "지정된 CLI 사용 (claude/codex/opencode)",
  "commands.items.yes": "CLI 권한 자동 승인 (claude --permission-mode acceptEdits, codex -a never)",
  "commands.items.use": "지정된 프로바이더 직접 사용 (프록시 없음)",
  "commands.items.pick": "프로바이더를 대화형으로 선택하여 시작",
  "commands.items.list": "모든 프로바이더와 profile 나열",
  "commands.items.configAddProvider": "새 프로바이더 추가",
  "commands.items.configAddProfile": "새 profile 추가",
  "commands.items.configDefaultClient": "기본 CLI 클라이언트 설정",
  "commands.items.configDefaultProfile": "기본 profile 설정",
  "commands.items.configResetPassword": "웹 UI 접근 비밀번호 재설정",
  "commands.items.configSync": "원격 동기화 백엔드에서 설정 가져오기",
  "commands.items.daemonStart": "zend 데몬 시작",
  "commands.items.daemonStop": "데몬 중지",
  "commands.items.daemonStatus": "데몬 상태 보기",
  "commands.items.daemonEnable": "시스템 서비스로 설치",
  "commands.items.daemonDisable": "시스템 서비스 제거",
  "commands.items.bind": "현재 디렉토리를 profile에 바인딩",
  "commands.items.bindCli": "현재 디렉토리를 지정된 CLI에 바인딩",
  "commands.items.unbind": "현재 디렉토리 바인딩 해제",
  "commands.items.status": "현재 디렉토리 바인딩 상태 표시",
  "commands.items.web": "브라우저에서 웹 관리 UI 열기 (데몬 자동 시작)",
  "commands.items.upgrade": "최신 버전으로 업그레이드",
  "commands.items.version": "버전 표시",
  "commands.items.completion": "셸 자동완성 스크립트 생성 (zsh/bash/fish)",
  "homepage.title": "멀티 CLI 환경 스위처"
}
